import React, { useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import AnnouncementBar from './AnnouncementBar';
import Header from './Header';
import Footer from './Footer';
import { serviceCards } from '../data/services';

const ServicesPage = () => {
  useServiceSeo(
    'Services | Pronto Notary | Maryland',
    "Explore Pronto Notary's mobile, online, business, healthcare, family, vehicle, and apostille services in Maryland."
  );

  return (
    <PageShell>
      <section className="bg-cream-dark px-6 pb-20 pt-16 md:pb-28 md:pt-24">
        <div className="mx-auto max-w-7xl">
          <div className="mx-auto max-w-3xl text-center">
            <Eyebrow>WHAT WE OFFER</Eyebrow>
            <h1 className="font-fraunces text-5xl leading-tight text-navy md:text-7xl">
              Every notary service,{' '}
              <span className="italic text-brass">in one place.</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-navy/70">
              From a single signature to a full apostille, here&apos;s everything we handle.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
            {serviceCards.map((service) => (
              <a
                key={service.href}
                href={service.href}
                className="group flex h-full flex-col rounded-2xl border border-line bg-cream p-8 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-brass/50 hover:shadow-md"
              >
                <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full border border-brass text-brass transition-colors group-hover:bg-brass group-hover:text-cream">
                  <SafeIcon icon={service.icon} size={22} />
                </div>
                <h2 className="font-fraunces text-2xl text-navy">{service.name}</h2>
                <p className="mt-4 flex-grow text-sm leading-relaxed text-navy/70">
                  {service.description}
                </p>
                <span className="mt-7 border-t border-dashed border-line pt-5 text-sm font-bold text-navy transition-colors group-hover:text-brass">
                  Learn more <span aria-hidden="true">→</span>
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
};

const PageShell = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-cream selection:bg-brass selection:text-cream">
    <AnnouncementBar />
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);

const Eyebrow = ({ children }) => (
  <span className="mb-5 block text-xs font-bold uppercase tracking-[0.2em] text-brass">
    {children}
  </span>
);

export const useServiceSeo = (title, description, serviceType = 'Notary Services') => {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'Pronto Notary',
      description,
      serviceType,
      telephone: '+1-240-571-3117',
      areaServed: [
        'Prince George\'s County, Maryland',
        'Montgomery County, Maryland',
        'Howard County, Maryland'
      ]
    });
    document.head.appendChild(script);

    return () => {
      script.remove();
      document.title = 'Pronto Notary | Mobile Notary & Apostille Services';
    };
  }, [title, description, serviceType]);
};

export default ServicesPage;